import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Input } from '../../../components/common/Form';
import ProfileSectionPage from '../../../components/ProfileSectionPage/ProfileSectionPage';
import InstagramIcon from '../../../assets/svgs/icons/Socials/InstagramIcon';
import FacebookIcon from '../../../assets/svgs/icons/Socials/FacebookIcon';
import SnapchatIcon from '../../../assets/svgs/icons/Socials/SnapchatIcon';
import TiktokIcon from '../../../assets/svgs/icons/Socials/TiktokIcon';
import TwitterIcon from '../../../assets/svgs/icons/Socials/TwitterIcon';
import SocialInputLabel from '../../../components/SocialsInputLabel';
import { useBrandContext } from '../../../contexts/BrandContext';
import { updateBrand } from '../../../api/brand';

import './styles/_brand-profile-socials.scss';
import BrandProfileActions from './BrandProfileActions';

const BrandSocialsPage = () => {
  const { currentBrand, refreshCurrentBrand } = useBrandContext();

  const [instagram, setInstagram] = useState('');
  const [tiktok, setTiktok] = useState('');
  const [facebook, setFacebook] = useState('');
  const [twitter, setTwitter] = useState('');
  const [snapchat, setSnapchat] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setInstagram(currentBrand?.socials?.instagram || '');
    setTiktok(currentBrand?.socials?.tiktok || '');
    setFacebook(currentBrand?.socials?.facebook || '');
    setTwitter(currentBrand?.socials?.twitter || '');
    setSnapchat(currentBrand?.socials?.snapchat || '');
  }, [currentBrand]);

  const handleSave = async () => {
    if (!currentBrand || isSaving) return;

    setIsSaving(true);

    try {
      await updateBrand(currentBrand.id, {
        socials: {
          instagram: instagram.trim(),
          tiktok: tiktok.trim(),
          facebook: facebook.trim(),
          twitter: twitter.trim(),
          snapchat: snapchat.trim()
        }
      });

      await refreshCurrentBrand();
      toast.success('Brand social media links saved successfully.');
    } catch (error) {
      console.error('Failed to save brand social media links:', error);
      toast.error('Failed to save brand social media links.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ProfileSectionPage title="SOCIAL MEDIA">
      <div className="brand-profile-socials-page">
        <div className="brand-profile-socials-inputs">
          <Input
            name="instagram"
            label={<SocialInputLabel icon={<InstagramIcon />} label="INSTAGRAM" />}
            className="brand-profile-socials-input"
            placeholder="https://instagram.com/username"
            value={instagram}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInstagram(e.target.value)}
          />

          <Input
            name="tiktok"
            label={<SocialInputLabel icon={<TiktokIcon />} label="TIKTOK" />}
            className="brand-profile-socials-input"
            placeholder="https://tiktok.com/@username"
            value={tiktok}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTiktok(e.target.value)}
          />

          <Input
            name="facebook"
            label={<SocialInputLabel icon={<FacebookIcon />} label="FACEBOOK" />}
            className="brand-profile-socials-input"
            placeholder="https://facebook.com/username"
            value={facebook}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFacebook(e.target.value)}
          />

          <Input
            name="twitter"
            label={<SocialInputLabel icon={<TwitterIcon />} label="TWITTER" />}
            className="brand-profile-socials-input"
            placeholder="https://twitter.com/username"
            value={twitter}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTwitter(e.target.value)}
          />

          <Input
            name="snapchat"
            label={<SocialInputLabel icon={<SnapchatIcon />} label="SNAPCHAT" />}
            className="brand-profile-socials-input"
            placeholder="https://snapchat.com/add/username"
            value={snapchat}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSnapchat(e.target.value)}
          />
        </div>

        <BrandProfileActions onSave={handleSave} isSaving={isSaving} />
      </div>
    </ProfileSectionPage>
  );
};

export default BrandSocialsPage;
